import { Box } from "@mui/material"
import BaseSettingsDisplay from "./BaseSettingsDisplay";
import { RslSetttingDto, SettingsTrackedDto } from "../../RslDataType";
import BaseSettingMultiselectDisplay from "./BaseSettingMultiselectDisplay";




export interface SettingsUiDisplayProps {
    id?: string,
    setting: RslSetttingDto,
    hide?: true
    index?: number,
    setIndex?: (v: number) => void
    subValue?: number,
    setSubValue?: (v: number) => void
    displayField?: true
    indexesDisplayField?: Array<number>
    
    setOptions?: (v: Array<SettingsTrackedDto>) => void
    options?: Array<SettingsTrackedDto>
    //esthétique
    width: number
    widthSettingName?: number
    widthName?: number
    top?: number,
    left?: number
}

const SettingsUiDisplay = (props: SettingsUiDisplayProps) => {

    let {setting, index, setIndex, displayField, indexesDisplayField, 
        width, widthName, widthSettingName, top, left} = props;

    if(setting.type === "classic")
        return <Box display={"flex"}>
            <BaseSettingsDisplay 
                setting={setting} 
                setIndex={setIndex}
                index={index}
                setSubValue={props.setSubValue}
                subValue={props.subValue}
                displayField={displayField}
                indexesDisplayField={indexesDisplayField}
                width={width}
                widthSettingName={widthSettingName}
                top={top}
                left={left}
                widthName={widthName}
            />
        </Box>
    
    return <Box display={"flex"}>
        <BaseSettingMultiselectDisplay
             setting={setting} 
             selected={props.options}
             setSelected={props.setOptions}
             top={top}
             left={left}

        />
    </Box>
}

export default SettingsUiDisplay;